import React from "react";

export const Teaching = (props) => {
  return (
    <div id="teaching" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <h2>Teaching</h2>
        </div>
        <br></br>
        <div className="col-md-8 col-md-offset-2 text-justify-xs">
          <div className="teaching-text">
            <p>UNIVERSITY OF SPLIT</p>
            <p>
              FACULTY OF ELECTRICAL ENGINEERING, MECHANICAL ENGINEERING AND
              NAVAL ARCHITECTURE
            </p>
            <br></br>
            <h3>Undergraduate courses</h3>
            <a href="https://nastava.fesb.unist.hr/nastava/predmeti/17590">
              Programming{" "}
            </a>
            <br></br>
            <a href="https://nastava.fesb.unist.hr/nastava/predmeti/17700">
              {" "}
              Object Oriented Programming{" "}
            </a>{" "}
            <h3>Graduate courses</h3>
            <a href="https://nastava.fesb.unist.hr/nastava/predmeti/17930">
              {" "}
              Programming Laguages and Compilers{" "}
            </a>{" "}
            <br></br>
            <a href="https://nastava.fesb.unist.hr/nastava/predmeti/17945">
              {" "}
              Geographic Information Systems{" "}
            </a>{" "}
            <br></br>
            <a href="https://nastava.fesb.unist.hr/nastava/predmeti/17933">
              {" "}
              Electroacoustics{" "}
            </a>{" "}
            <h3>Postgraduate courses</h3>
            <p>Room Acoustics</p>
            <p>Advanced Geographic Information Systems</p>
          </div>
        </div>
      </div>
    </div>
  );
};
